<div class="dialog-content-wrapper">
  <div class="unsave-header">
    {{ 'add_credits' | translate }}
  </div>
  <div class="add-credits-modal m-0" mat-dialog-content>
    <mat-form-field>
      <input type="number" matInput placeholder="Credits" [(ngModel)]="credits">
    </mat-form-field>
    @if (showControls) {
      <div class="warning">
        {{ 'add_credits_warning' | translate }}
      </div>
    }
    <div>
      <div class="users title">
        <div class="user-name">{{ 'main.frontuser' | translate }}</div>
        <div class="user-has-rewards">
        </div>
        <div class="add-logo">
          {{ 'progress' | translate }}
        </div>
      </div>
      <div class="users-table">
        @for (user of users; track user) {
          <div class="users">
            <div class="user-name" [style.color]="user.showControl ? 'orangered' : 'black'">
              {{ user?.frontUser?.firstName }} {{ user?.frontUser?.lastName }}
            </div>
            <div class="user-has-rewards">
            </div>
            @if (!user.showControl) {
              <div class="add-logo" [ngClass]="{'green-logo' : user.addCredit}">
                <mat-icon>done_outline</mat-icon>
              </div>
            }
            @if (user.showControl) {
              <div class="add-logo red-logo">
                <mat-icon>close</mat-icon>
              </div>
            }
          </div>
        }
      </div>
    </div>
  </div>

  <div mat-dialog-actions class="m-0 p-10 unsave-footer" fxLayout="row" fxLayoutAlign="end center">
    <button mat-button (click)="addCredits()" [disabled]="!credits">
      <span>{{ 'add_credits' | translate }}</span>
    </button>
  </div>
</div>
